export enum FieldType {
  TEXTAREA = 'TEXTAREA',
  TEXT = 'TEXT',
  NUMBER = 'NUMBER',
  SELECT = 'SELECT',
  DATE = 'DATE',
  IMAGE = 'IMAGE',
  RADIO = 'RADIO',
  CHECKBOX = 'CHECKBOX',
  SIGNATURE = 'SIGNATURE',
  INITIAL = 'INITIAL',
  SIGNED_DATE = 'SIGNED_DATE',
}

export enum FieldAlign {
  LEFT = 'LEFT',
  CENTER = 'CENTER',
  RIGHT = 'RIGHT',
}

export enum InputFormatType {
  DATE = 'DATE',
  NUMBER = 'NUMBER',
  CURRENCY = 'CURRENCY',
  PERCENTAGE = 'PERCENTAGE',
}

export const NUMBER_INPUT_FORMATS = [
  InputFormatType.NUMBER,
  InputFormatType.CURRENCY,
  InputFormatType.PERCENTAGE,
];
